import React, { useEffect, useState } from 'react';
import { Box, MenuItem, SelectChangeEvent } from '@mui/material';
import clsx from 'clsx';
import { useNavigate, useParams } from 'react-router-dom';
import type {
  CarBrandList,
  CarModelList,
  CarSubTypeList,
  CarTypeList,
} from 'entities/car/model/types';
import { apiClient } from 'shared/api';
import { useUser } from 'shared/api/tanstack';
import { ButtonCustom } from 'shared/ui/button-custom';
import { DownloadButton } from 'shared/ui/download-button';
import { FileInputCustom } from 'shared/ui/file-input-custom';
import { SelectInputSmall } from 'shared/ui/select-input-small';
import { TextInput } from 'shared/ui/text-input';
import { TextInputSmall } from 'shared/ui/text-input-small';
import styles from './application.module.scss';

export const Application = () => {
  const { type, uid, oid } = useParams();
  const navigate = useNavigate();

  const { data: user } = useUser();

  async function handleConfirm() {
    try {
      const data = { id: offerData?.custom_uid };
      const url = type == 'select' ? '/select-offers/complete' : '/leasing-offers/complete';
      const responseOffer = await apiClient.post(url, data);
      postDataApp();
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
    }
  }

  async function handleCancel() {
    try {
      const data = { id: offerData?.custom_uid };
      const url = type == 'select' ? '/select-offers/cancel' : '/leasing-offers/cancel';
      const responseOffer = await apiClient.post(url, data);
      postDataApp();
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
    }
  }

  const [dynamicField, setDynamicField] = useState<any>([]);
  const [appData, setAppData] = useState<any>([]);
  const [offerData, setOfferData] = useState<any>([]);
  const [filledOffers, setFilledOffers] = useState<any[]>([]);
  const [loading, setLoading] = useState<any>(false);
  const [fillDisplay, setFillDisplay] = useState<any>(false);

  const [modelValueList, setModelValueList] = useState<CarModelList>([]);
  const [quantity, setQuantity] = useState<any>([]);
  const [bounty, setBounty] = useState<any>([]);
  const [price, setPrice] = useState<any>([]);
  const [delivery_time, setDelivery_time] = useState<any>([]);

  // const [initial_payment, setInitial_payment] = useState<any>([]);
  const [sum_total, setSum_total] = useState<any>([]);
  const [month_pay, setMonth_pay] = useState<any>([]);
  // const [sum_diff, setSum_diff] = useState<any>([]);
  // const [rise_price, setRise_price] = useState<any>([]);
  // const [lease_period, setLease_period] = useState<any>([]);

  const postDataApp = async () => {
    try {
      if (type == 'select') {
        const data = { id: uid };
        const responseApp = await apiClient.post('/select-applications/app-fill', data);
        setAppData(responseApp?.data?.data?.application);
      } else {
        const data = { id: uid };
        const responseApp = await apiClient.post('/leasing-applications/app-fill', data);
        setAppData(responseApp?.data?.data?.application);
      }
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
    }
  };

  const postOfferStatus = async () => {
    try {
      let responseApp;
      let responseData;
      if (type == 'select') {
        const data = { id: oid };
        const response = await apiClient.post('/select-offers/app-offer', data);
        responseData = response?.data?.data;
        responseApp = responseData?.offer;
        setOfferData(responseApp);
        setFilledOffers(responseData?.filled_offers || []);
      } else {
        const data = { id: oid };
        const response = await apiClient.post('/leasing-offers/app-offer', data);
        responseData = response?.data?.data;
        responseApp = responseData?.offer;
        setOfferData(responseApp);
        setFilledOffers(responseData?.filled_offers || []);
      }

      if (responseApp?.status_accept || responseApp?.status_employer_approve) {
        navigate(`/app/full/${type}/${uid}/${oid}`);
      }
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
    }
  };

  useEffect(() => {
    postDataApp();
    postOfferStatus();
  }, [oid, type, uid]);

  const [typeValueList, setTypeValueList] = useState<CarTypeList>([]);
  const [typeValue, setTypeValue] = useState<number | string>('');
  const [subtypeValueList, setSubTypeValueList] = useState<CarSubTypeList>([]);
  const [subtypeValue, setSubTypeValue] = useState<number | string>('');

  useEffect(() => {
    setDynamicField(appData?.car_params || []);
    getBrandsForSubType();
  }, [appData, subtypeValue, subtypeValueList]);

  const handleFillOffer = async () => {
    const formData = new FormData();
    if (bounty.toString().length) {
      formData.append('bounty', bounty.toString());
    } else {
      setBountyErr(true);
    }

    // console.log({
    //   brandOther,
    //   modelOther,
    //   otherInfo,
    //   brand,
    //   model,
    // });

    if (oid) {
      formData.append('docId', oid.toString());
    }
    if (condition.toString().length) {
      formData.append('condition', condition.toString());
    } else {
      setConditionErr(true);
    }
    if (brandOther.toString().length) {
      formData.append('car_brand', brandOther.toString());
    } else if (brand.toString().length) {
      let value = !isNaN(+brand) ? brandValueList.find((b) => b.id === brand)?.name : brand;
      value = +brand === 0 ? appData.car_brand : value;
      formData.append('car_brand', value as string);
    } else {
      setBrandErr(true);
    }
    if (modelOther.toString().length) {
      formData.append('car_model', modelOther.toString());
    } else if (model.toString().length) {
      formData.append('car_model', model.toString());
    } else {
      setModelErr(true);
    }
    if (quantity.toString().length) {
      formData.append('quantity', quantity.toString());
    } else {
      setQuantityErr(true);
    }
    if (price.toString().length) {
      formData.append('price', price.toString());
    } else {
      setPriceErr(true);
    }
    if (available.toString().length) {
      formData.append('availability', available.toString());
    } else {
      setAvailableErr(true);
    }
    if (delivery_time.toString().length) {
      formData.append('delivery_time', delivery_time.toString());
    } else {
      setDelivery_timeErr(true);
    }
    if (city.toString().length) {
      formData.append('city', city.toString());
    } else {
      setCityErr(true);
    }

    if (otherInfo.toString().length) {
      formData.append('other_info', otherInfo.toString());
    }

    if (month_pay.toString().length) {
      formData.append('month_pay', month_pay.toString());
    }
    // else {
    //     setMonth_payErr(true)
    // }
    if (sum_total.toString().length) {
      formData.append('sum_total', sum_total.toString());
    } else {
      setSum_totalErr(true);
    }
    // if (initial_payment.toString().length) {
    //     formData.append('initial_payment', initial_payment.toString())
    // } else {
    //     setInitial_paymentErr(true)
    // }
    // if (lease_period.toString().length) {
    //     formData.append('lease_period', lease_period.toString())
    // } else {
    //     setLease_periodErr(true)
    // }
    // if (sum_diff.toString().length) {
    //     formData.append('sum_diff', sum_diff.toString())
    // }
    // if (rise_price.toString().length) {
    //     formData.append('rise_price', rise_price.toString())
    // }

    if (kp && kp[0]) {
      formData.append('kp', kp[0]);
    }

    if (calc && calc[0]) {
      formData.append('calc', calc[0]);
    }

    try {
      setLoading(true);
      const data = formData;
      const url = type == 'select' ? '/select-offers/fill' : '/leasing-offers/fill';

      const responseOffer = await apiClient.post(url, data);
      const responseData = responseOffer?.data?.data;
      const nextOfferUid = responseData?.next_offer_custom_uid;

      if (Array.isArray(responseData?.filled_offers)) {
        setFilledOffers(responseData.filled_offers);
      }

      if (nextOfferUid) {
        navigate(`/app/${type}/${uid}/${nextOfferUid}`);
      } else {
        postOfferStatus();
      }
    } catch (error) {
      console.error('Ошибка при отправке данных:', error);
      setFillDisplay(true);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeQuantity = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuantity(event.target.value);
    setQuantityErr(!event.target.value);
  };

  const handleChangeBounty = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBounty(event.target.value);
    setBountyErr(!event.target.value);
  };

  const handleChangePrice = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPrice(event.target.value);
    setPriceErr(!event.target.value);
  };

  const handleChangeCity = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCity(event.target.value);
    setCityErr(!event.target.value);
  };

  const handleChangeDelivery_time = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDelivery_time(event.target.value);
    setDelivery_timeErr(!event.target.value);
  };

  // const handleChangeInitial_payment = (event: React.ChangeEvent<HTMLInputElement>) => {
  //     setInitial_payment(event.target.value);
  //     setInitial_paymentErr(!event.target.value)
  // }
  const handleChangeSum_total = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSum_total(event.target.value);
    setSum_totalErr(!event.target.value);
  };
  const handleChangeMonth_pay = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMonth_pay(event.target.value);
    setMonth_payErr(!event.target.value);
  };
  // const handleChangeLease_period = (event: React.ChangeEvent<HTMLInputElement>) => {
  //     setLease_period(event.target.value);
  //     setLease_periodErr(!event.target.value)
  // }
  // const handleChangeSum_diff = (event: React.ChangeEvent<HTMLInputElement>) => {
  //     setSum_diff(event.target.value);
  // }
  // const handleChangeRise_price = (event: React.ChangeEvent<HTMLInputElement>) => {
  //     setRise_price(event.target.value);
  // }

  const renderApp = () => {
    if (type == 'select') {
      return (
        <Box className={styles.appWrapper}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Статус заявки</span>
            <span className={styles.appDescValue}>
              {appData?.fulfilled === false ? 'Черновик' : appData?.status_app}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Состояние</span>
            <span className={styles.appDescValue}>{appData?.condition}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Cпособ покупки</span>
            <span className={styles.appDescValue}>{appData?.pay_method}</span>
          </Box>

          {appData?.inn && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>ИНН</span>
              <span className={styles.appDescValue}>{appData?.inn}</span>
            </Box>
          )}

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{appData?.quantity}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {appData?.car_type ? `${appData?.car_type} - ` : ''}{' '}
              {appData?.car_subtype ? appData?.car_subtype : ''}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{appData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{appData?.vehicle}</span>
          </Box>

          {dynamicField?.map((field: any) => (
            <Box key={field?.fieldName} className={styles.appDesc}>
              <span className={styles.appDescTitle}>{field?.fieldName}</span>
              <span className={styles.appDescValue}>
                {Array.isArray(field?.fieldValue) ? field.fieldValue.join(', ') : field?.fieldValue}
              </span>
            </Box>
          ))}

          {appData?.kp && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Имеющееся предложение</span>
              <DownloadButton fileUrl={appData?.kp?.url} title={appData?.kp?.name} />
            </Box>
          )}
        </Box>
      );
    }
    if (type == 'leasing') {
      return (
        <Box className={styles.appWrapper}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Статус заявки</span>
            <span className={styles.appDescValue}>
              {appData?.fulfilled === false ? 'Черновик' : appData?.status_app}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>ИНН</span>
            <span className={styles.appDescValue}>{appData?.inn}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {appData?.car_type ? `${appData?.car_type} - ` : ''}{' '}
              {appData?.car_subtype ? appData?.car_subtype : ''}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{appData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{appData?.vehicle}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{appData?.quantity}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Стоимость предмета лизинга</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(appData?.price as number)} ₽
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Первоначальный взнос</span>
            <span className={styles.appDescValue}>{appData?.initial_payment} %</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Срок лизинга</span>
            <span className={styles.appDescValue}>{appData?.lease_period} мес.</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Тип оплаты</span>
            <span className={styles.appDescValue}>{appData?.payment_type}</span>
          </Box>

          {appData?.kp && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Имеющееся предложение</span>
              <DownloadButton fileUrl={appData?.kp?.url} title={appData?.kp?.name} />
            </Box>
          )}
        </Box>
      );
    }
  };

  const [quantityErr, setQuantityErr] = useState(false);
  const [bountyErr, setBountyErr] = useState(false);
  const [delivery_timeErr, setDelivery_timeErr] = useState(false);
  const [priceErr, setPriceErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);

  const [availableErr, setAvailableErr] = useState(false);
  const [modelErr, setModelErr] = useState(false);
  const [typeErr, setTypeErr] = useState(false);
  const [subtypeErr, setSubTypeErr] = useState(false);
  const [brandErr, setBrandErr] = useState(false);
  const [conditionErr, setConditionErr] = useState(false);

  const [initial_paymentErr, setInitial_paymentErr] = useState(false);
  const [sum_totalErr, setSum_totalErr] = useState(false);
  const [month_payErr, setMonth_payErr] = useState(false);
  const [lease_periodErr, setLease_periodErr] = useState(false);

  const [condition, setCondition] = useState<string>('');
  const [available, setAvailable] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [otherInfo, setOtherInfo] = useState<string>('');

  const [kp, setKp] = useState<any>();
  const [calc, setCalc] = useState<any>();

  const handleChangeKp = (event: any) => {
    setKp(event.target.files);
  };
  const handleChangeCalc = (event: any) => {
    setCalc(event.target.files);
  };

  const [subtypeMain, setSubtypeMain] = useState<number | string>('');

  const [brand, setBrand] = useState<number | string>('');
  const [brandOther, setBrandOther] = useState<string>('');
  const [brandValueList, setBrandValueList] = useState<CarBrandList>([]);
  const [model, setModel] = useState<number | string>('');
  const [modelOther, setModelOther] = useState<string>('');

  const getBrandsForSubType = async () => {
    try {
      const subtypeName = subtypeValue || appData.car_subtype;
      const subtypeId = isNaN(subtypeName)
        ? subtypeValueList.find((st) => st.name === subtypeName)?.id
        : subtypeName;

      if (subtypeId) {
        const response = await apiClient.post('/car-brands/subtype', {
          subtypeId,
        });
        const data = await response;
        setBrandValueList([
          ...data.data.data,
          { id: 0, name: 'Иное', value: 'other', car_params: [] },
        ]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getVehicleForBrandAndSubType = async () => {
    if (brand === 0) {
      setModelValueList([{ id: 0, name: 'Иное', value: 'other', car_params: [] }]);
    } else {
      try {
        const subtypeName = subtypeValue || appData.car_subtype;
        const subtypeId = isNaN(subtypeName)
          ? subtypeValueList.find((st) => st.name === subtypeName)?.id
          : subtypeName;

        const response = await apiClient.post('/vehicles/brandSubType', {
          brandId: brand,
          subtypeId: subtypeId,
        });
        const data = await response;
        setModelValueList([
          ...data.data.data,
          { id: 0, name: 'Иное', value: 'other', car_params: [] },
        ]);
      } catch (e) {
        setModelValueList([{ id: 0, name: 'Иное', value: 'other', car_params: [] }]);
        console.log(e);
      }
    }
  };

  useEffect(() => {
    getVehicleForBrandAndSubType();
  }, [appData, brand, subtypeValue]);

  const getVehicleSubtype = async (model: number | string) => {
    if (model === 0) {
      return;
    }
    try {
      const response = await apiClient.post('/vehicles/subtype', { modelId: model });
      const data = await response;
      setSubtypeMain(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };

  const handleChangeAvailable = (event: SelectChangeEvent<unknown>) => {
    setAvailable(event.target.value as string);
    setAvailableErr(false);
  };

  const handleChangeCondition = (event: SelectChangeEvent<unknown>) => {
    setCondition(event.target.value as string);
    setConditionErr(false);
  };
  const handleChangeBrand = (event: SelectChangeEvent<unknown>) => {
    setBrand(event.target.value as string);
    setModel('');
    setBrandErr(false);
  };
  const handleChangeModel = (event: SelectChangeEvent<unknown>) => {
    setModel(event.target.value as string);
    getVehicleSubtype(event.target.value as number);
    setModelErr(false);
  };
  const handleChangeType = (event: SelectChangeEvent<unknown>) => {
    setTypeValue(event.target.value as string);
    setTypeErr(false);
  };

  const handleChangeSubType = (event: SelectChangeEvent<unknown>) => {
    setSubTypeValue(event.target.value as string);
    setSubTypeErr(false);
  };

  useEffect(() => {
    setFillDisplay(!offerData.status_filled);
  }, [offerData]);

  const fetchCarTypesData = async () => {
    try {
      const response1 = await apiClient.get('/car-types/all');
      const data1 = await response1;
      setTypeValueList([
        ...(data1.data.data as CarTypeList),
        //
      ]);
    } catch (error) {
      setTypeValueList([]);
      console.error('Ошибка при загрузке данных:', error);
    }
  };

  useEffect(() => {
    fetchCarTypesData();
  }, [appData]);

  const fetchCarSubTypesData = async () => {
    const typeName = typeValue || appData.car_type;
    const carType = typeValueList.find((t) => t.name === typeName);
    try {
      if (carType?.id) {
        const response2 = await apiClient.post('/car-subtypes/subtypes', {
          typeId: carType.id,
        });
        const data2 = await response2;
        setSubTypeValueList([
          ...(data2.data.data as CarSubTypeList),
          { id: 0, name: 'Иное', value: 'other' },
        ]);
      }
    } catch (error) {
      setTypeValueList([]);
      console.error('Ошибка при загрузке данных:', error);
    }
  };

  useEffect(() => {
    fetchCarSubTypesData();
  }, [appData, typeValueList, typeValue]);

  const renderOffer = () => {
    if (type == 'select') {
      return (
        <Box className={styles.offerBlock}>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите состояние</span>
            <SelectInputSmall
              value={condition}
              onChange={handleChangeCondition}
              error={conditionErr}
              placeholder={'Выберите состояние'}
            >
              <MenuItem value='Новый'>Новый</MenuItem>
              <MenuItem value='С пробегом'>С пробегом</MenuItem>
            </SelectInputSmall>
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите тип ТС</span>
            {appData.car_type ? (
              <TextInputSmall
                name={'car_type'}
                type={'text'}
                disabled={appData.car_type}
                value={appData.car_type}
              />
            ) : (
              <SelectInputSmall
                value={typeValue}
                required
                error={typeErr}
                onChange={handleChangeType}
                placeholder={'Выберите тип ТС'}
              >
                {typeValueList.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </SelectInputSmall>
            )}
          </Box>
          {(appData.car_type && !typeValueList.find((type) => type.name === appData.car_type)) ||
          (appData.car_subtype &&
            !subtypeValueList.find((type) => type.name === appData.car_subtype)) ? (
            <Box className={styles.offerDesc}>
              <span className={styles.appDescTitle}>Укажите параметры модели</span>
              <TextInputSmall
                name={'vehicle_other'}
                type={'text'}
                value={modelOther}
                onChange={(event) => setModelOther(event.target.value)}
              />
            </Box>
          ) : (
            <>
              <Box className={styles.offerDesc}>
                <span className={styles.appDescTitle}>Укажите подтип ТС</span>
                {appData.car_subtype &&
                !typeValueList.find((type) => type.name === appData.car_type) ? (
                  <TextInputSmall
                    name={'car_subtype'}
                    type={'text'}
                    disabled={appData.car_subtype}
                    value={appData.car_subtype}
                  />
                ) : (
                  <SelectInputSmall
                    value={subtypeValue}
                    required
                    error={subtypeErr}
                    onChange={handleChangeSubType}
                    placeholder={'Укажите подтип ТС'}
                  >
                    {subtypeValueList.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </SelectInputSmall>
                )}
              </Box>
              <Box className={styles.offerDesc}>
                <span className={styles.appDescTitle}>Укажите марку</span>
                <SelectInputSmall
                  value={brand}
                  required
                  error={brandErr}
                  onChange={handleChangeBrand}
                  placeholder={'Выберите марку'}
                >
                  {brandValueList.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </SelectInputSmall>
              </Box>
              {brand !== 0 ? (
                <Box className={styles.offerDesc}>
                  <span className={styles.appDescTitle}>Укажите модель</span>
                  <SelectInputSmall
                    value={model}
                    required
                    error={modelErr}
                    onChange={handleChangeModel}
                    placeholder={'Выберите модель'}
                  >
                    {modelValueList.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </SelectInputSmall>
                </Box>
              ) : (
                <Box className={styles.offerDesc}>
                  <span className={styles.appDescTitle}>Укажите параметры модели</span>
                  <TextInputSmall
                    name={'vehicle_other'}
                    type={'text'}
                    value={modelOther}
                    onChange={(event) => setModelOther(event.target.value)}
                  />
                </Box>
              )}

              {model === 0 && (
                <Box className={styles.offerDesc}>
                  <span className={styles.appDescTitle}>Укажите параметры модели</span>
                  <TextInputSmall
                    name={'vehicle_other'}
                    type={'text'}
                    value={modelOther}
                    onChange={(event) => setModelOther(event.target.value)}
                  />
                </Box>
              )}
            </>
          )}

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите кол-во ТС</span>
            <TextInputSmall
              onChange={handleChangeQuantity}
              value={quantity}
              error={quantityErr}
              required
              name={'quantity'}
              type={'number'}
              placeholder={'Введите кол-во ТС'}
            />
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите стоимость</span>
            <TextInputSmall
              onChange={handleChangePrice}
              value={price}
              error={priceErr}
              required
              name={'price'}
              type={'number'}
              placeholder={'Введите стоимость'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите наличие</span>
            <SelectInputSmall
              value={available}
              onChange={handleChangeAvailable}
              error={availableErr}
              placeholder={'Выберите наличие'}
            >
              <MenuItem value='В наличии'>В наличии</MenuItem>
              <MenuItem value='Под заказ'>Под заказ</MenuItem>
            </SelectInputSmall>
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите срок поставки</span>
            <TextInputSmall
              onChange={handleChangeDelivery_time}
              value={delivery_time}
              error={delivery_timeErr}
              required
              name={'delivery_time'}
              type={'text'}
              placeholder={'Введите срок поставки'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите ваш город</span>
            <TextInputSmall
              onChange={handleChangeCity}
              value={city}
              error={cityErr}
              required
              name={'city'}
              type={'text'}
              placeholder={'Введите ваш город'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Размер вознаграждения, %</span>
            <TextInputSmall
              onChange={handleChangeBounty}
              value={bounty}
              error={bountyErr}
              required
              name={'bounty'}
              type={'number'}
              placeholder={'Введите размер вознаграждения'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Прикрепите КП</span>
            <FileInputCustom
              value={kp}
              onChange={handleChangeKp}
              sx={{ height: '40px' }}
              text={'Прикрепить КП'}
            />
          </Box>

          {fillDisplay && (
            <Box className={styles.acceptBtn}>
              <ButtonCustom disabled={loading} onClick={handleFillOffer}>
                {loading ? 'Подождите...' : 'Отправить предложение'}
              </ButtonCustom>
            </Box>
          )}
          {offerData?.status_employer_approve &&
            appData?.status_app !== 'Отменена' &&
            appData?.status_app !== 'Выполнена' &&
            appData?.status_app !== 'Закрыта' && (
              <>
                {['agent', 'client'].includes(user?.user_type) && (
                  <Box className={styles.cancelButton}>
                    <ButtonCustom className={styles.canceledBtn} onClick={handleCancel}>
                      Отказ
                    </ButtonCustom>
                  </Box>
                )}
                <Box className={styles.acceptBtn}>
                  <ButtonCustom className={styles.completedBtn} onClick={handleConfirm}>
                    Закрыть сделку
                  </ButtonCustom>
                </Box>
              </>
            )}
        </Box>
      );
    }

    if (
      type == 'select' &&
      (appData.status_app == 'Ожидает подтвержд.' ||
        appData.status_app == 'На оформлении' ||
        appData.status_app == 'Выполнена' ||
        appData.status_app == 'Закрыта' ||
        appData.status_app == 'Отменена')
    ) {
      return (
        <Box className={styles.offerBlockCanceled}>
          <Box className={styles.disabledStyle} />
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите состояние</span>
            <SelectInputSmall
              disabled
              value={condition}
              onChange={handleChangeCondition}
              error={conditionErr}
              placeholder={'Выберите состояние'}
            >
              <MenuItem value='Новый'>Новый</MenuItem>
              <MenuItem value='С пробегом'>С пробегом</MenuItem>
            </SelectInputSmall>
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите тип ТС</span>
            <TextInputSmall name={'car_type'} type={'text'} disabled value={appData.car_type} />
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите марку</span>
            <SelectInputSmall
              value={brand}
              required
              disabled
              error={brandErr}
              onChange={handleChangeBrand}
              placeholder={'Выберите марку'}
            >
              {brandValueList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </SelectInputSmall>
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите модель</span>
            <SelectInputSmall
              disabled
              value={model}
              required
              error={modelErr}
              onChange={handleChangeModel}
            >
              {modelValueList.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </SelectInputSmall>
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите кол-во ТС</span>
            <TextInputSmall
              disabled
              onChange={handleChangeQuantity}
              value={quantity}
              error={quantityErr}
              required
              name={'quantity'}
              type={'number'}
              placeholder={'Введите кол-во ТС'}
            />
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите стоимость</span>
            <TextInputSmall
              disabled
              onChange={handleChangePrice}
              value={price}
              error={priceErr}
              required
              name={'price'}
              type={'number'}
              placeholder={'Введите стоимость'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите наличие</span>
            <SelectInputSmall
              disabled
              value={available}
              onChange={handleChangeAvailable}
              error={availableErr}
              placeholder={'Выберите наличие'}
            >
              <MenuItem value='В наличии'>В наличии</MenuItem>
              <MenuItem value='Под заказ'>Под заказ</MenuItem>
            </SelectInputSmall>
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите срок поставки</span>
            <TextInputSmall
              disabled
              onChange={handleChangeDelivery_time}
              value={delivery_time}
              error={delivery_timeErr}
              required
              name={'delivery_time'}
              type={'text'}
              placeholder={'Введите срок поставки'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите ваш город</span>
            <TextInputSmall
              disabled
              onChange={handleChangeCity}
              value={city}
              error={cityErr}
              required
              name={'city'}
              type={'text'}
              placeholder={'Введите ваш город'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Размер вознаграждения, %</span>
            <TextInputSmall
              disabled
              onChange={handleChangeBounty}
              value={bounty}
              error={bountyErr}
              required
              name={'bounty'}
              type={'number'}
              placeholder={'Введите размер вознаграждения'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Прикрепите КП</span>
            <FileInputCustom
              disabled
              value={kp}
              onChange={handleChangeKp}
              sx={{ height: '40px' }}
              text={'Прикрепить КП'}
            />
          </Box>

          {fillDisplay && (
            <Box className={styles.acceptBtn}>
              <ButtonCustom disabled>
                {loading ? 'Подождите...' : 'Отправить предложение'}
              </ButtonCustom>
            </Box>
          )}
        </Box>
      );
    }

    if (
      type == 'leasing' &&
      (appData.status_app == 'Новая' || appData.status_app == 'В обработке')
    ) {
      return (
        <Box className={styles.offerBlock}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {appData?.car_type ? `${appData?.car_type} - ` : ''}{' '}
              {appData?.car_subtype ? appData?.car_subtype : ''}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{appData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{appData?.vehicle}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{appData?.quantity}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Стоимость предмета лизинга</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(appData?.price as number)} ₽
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Первоначальный взнос</span>
            <span className={styles.appDescValue}>{appData?.initial_payment} %</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Срок лизинга</span>
            <span className={styles.appDescValue}>{appData?.lease_period} мес.</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Тип оплаты</span>
            <span className={styles.appDescValue}>{appData?.payment_type}</span>
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите общ. сумму лиз. плат.</span>
            <TextInputSmall
              onChange={handleChangeSum_total}
              value={sum_total}
              error={sum_totalErr}
              name={'sum_total'}
              required
              type={'number'}
              placeholder={'Введите общ. сумму лиз...'}
            />
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите размер ежемес. плат.</span>
            <TextInputSmall
              onChange={handleChangeMonth_pay}
              value={month_pay}
              name={'month_pay'}
              type={'number'}
              placeholder={'Введите размер ежемес...'}
            />
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите ваш город</span>
            <TextInputSmall
              onChange={handleChangeCity}
              value={city}
              error={cityErr}
              name={'city'}
              required
              type={'text'}
              placeholder={'Введите ваш город'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Размер вознаграждения, %</span>
            <TextInputSmall
              onChange={handleChangeBounty}
              value={bounty}
              error={bountyErr}
              required
              name={'bounty'}
              type={'number'}
              placeholder={'Введите размер вознаграждения'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Прикрепите расчет по форме</span>
            <FileInputCustom
              value={calc}
              onChange={handleChangeCalc}
              sx={{ height: '40px' }}
              text={'Прикрепить расчет'}
            />
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Прикрепите КП</span>
            <FileInputCustom
              value={kp}
              onChange={handleChangeKp}
              sx={{ height: '40px' }}
              text={'Прикрепить КП'}
            />
          </Box>

          {fillDisplay && (
            <Box className={styles.acceptBtn}>
              <ButtonCustom disabled={loading} onClick={handleFillOffer}>
                {loading ? 'Подождите...' : 'Отправить предложение'}
              </ButtonCustom>
            </Box>
          )}
        </Box>
      );
    }
    if (
      type == 'leasing' &&
      (appData.status_app == 'Ожидает подтвержд.' ||
        appData.status_app == 'На оформлении' ||
        appData.status_app == 'Выполнена' ||
        appData.status_app == 'Закрыта' ||
        appData.status_app == 'Отменена')
    ) {
      return (
        <Box className={styles.offerBlockCanceled}>
          <Box className={styles.disabledStyle} />
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {appData?.car_type ? `${appData?.car_type} - ` : ''}{' '}
              {appData?.car_subtype ? appData?.car_subtype : ''}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{appData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{appData?.vehicle}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{appData?.quantity}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Стоимость предмета лизинга</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(appData?.price as number)} ₽
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Первоначальный взнос</span>
            <span className={styles.appDescValue}>{appData?.initial_payment} %</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Срок лизинга</span>
            <span className={styles.appDescValue}>{appData?.lease_period} мес.</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Тип оплаты</span>
            <span className={styles.appDescValue}>{appData?.payment_type}</span>
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите общ. сумму лиз. плат.</span>
            <TextInputSmall
              onChange={handleChangeSum_total}
              value={sum_total}
              error={sum_totalErr}
              name={'sum_total'}
              required
              type={'number'}
              placeholder={'Введите общ. сумму лиз...'}
            />
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите размер ежемес. плат.</span>
            <TextInputSmall
              onChange={handleChangeMonth_pay}
              value={month_pay}
              name={'month_pay'}
              type={'number'}
              placeholder={'Введите размер ежемес...'}
            />
          </Box>
          {/* <Box className={styles.offerDesc}>*/}
          {/*    <span className={styles.appDescTitle}>Укажите разницу</span>*/}
          {/*    <TextInputSmall onChange={handleChangeSum_diff} value={sum_diff}*/}
          {/*                    name={'sum_diff'} type={'number'} placeholder={'Введите разницу'}/>*/}
          {/* </Box>*/}
          {/* <Box className={styles.offerDesc}>*/}
          {/*    <span className={styles.appDescTitle}>Укажите удорожание</span>*/}
          {/*    <TextInputSmall onChange={handleChangeRise_price} value={rise_price}*/}
          {/*                    name={'rise_price'} type={'number'} placeholder={'Введите удорожание'}/>*/}
          {/* </Box>*/}
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Укажите ваш город</span>
            <TextInputSmall
              onChange={handleChangeCity}
              value={city}
              error={cityErr}
              name={'city'}
              required
              type={'text'}
              placeholder={'Введите ваш город'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Размер вознаграждения, %</span>
            <TextInputSmall
              onChange={handleChangeBounty}
              value={bounty}
              error={bountyErr}
              required
              name={'bounty'}
              type={'number'}
              placeholder={'Введите размер вознаграждения'}
            />
          </Box>

          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Прикрепите расчет по форме</span>
            <FileInputCustom
              value={calc}
              onChange={handleChangeCalc}
              sx={{ height: '40px' }}
              text={'Прикрепить расчет'}
            />
          </Box>
          <Box className={styles.offerDesc}>
            <span className={styles.appDescTitle}>Прикрепите КП</span>
            <FileInputCustom
              value={kp}
              onChange={handleChangeKp}
              sx={{ height: '40px' }}
              text={'Прикрепить КП'}
            />
          </Box>

          {fillDisplay && (
            <Box className={styles.acceptBtn}>
              <ButtonCustom disabled={loading} onClick={handleFillOffer}>
                {loading ? 'Подождите...' : 'Отправить предложение'}
              </ButtonCustom>
            </Box>
          )}
        </Box>
      );
    }
  };

  const isStock = (status: string) => {
    return status == 'В наличии';
  };
  const isOrder = (status: string) => {
    return status == 'Под заказ';
  };

  const renderFillOffer = () => {
    if (type == 'select') {
      return (
        <Box className={styles.offerBlock}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Состояние</span>
            <span className={styles.appDescValue}>{offerData?.condition}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{offerData?.quantity}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {offerData?.car_type} - {offerData?.car_subtype}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{offerData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{offerData?.vehicle}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Стоимость</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(offerData?.price as number)} ₽
            </span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Наличие</span>
            <span
              className={clsx([
                `${styles.appDescValue}`,
                isStock(offerData?.availability) && `${styles.stock}`,
                isOrder(offerData?.availability) && `${styles.order}`,
              ])}
            >
              {offerData?.availability}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Срок поставки</span>
            <span className={styles.appDescValue}>{offerData?.delivery_time}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Город</span>
            <span className={styles.appDescValue}>{offerData?.city}</span>
          </Box>

          {offerData?.other_info && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Дополнительная информация</span>
              <span className={styles.appDescValue}>{offerData?.other_info}</span>
            </Box>
          )}

          {offerData?.kp && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Коммерческое предложение</span>
              <DownloadButton fileUrl={offerData?.kp?.url} title={offerData?.kp?.name} />
            </Box>
          )}
        </Box>
      );
    }
    if (type == 'leasing') {
      return (
        <Box className={styles.offerBlock}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {appData?.car_type ? `${appData?.car_type} - ` : ''}{' '}
              {appData?.car_subtype ? appData?.car_subtype : ''}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{appData?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{appData?.vehicle}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{appData?.quantity}</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Стоимость предмета лизинга</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(appData?.price as number)} ₽
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Первоначальный взнос</span>
            <span className={styles.appDescValue}>{appData?.initial_payment} %</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Срок лизинга</span>
            <span className={styles.appDescValue}>{appData?.lease_period} мес.</span>
          </Box>

          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Общая сумма лизинговых платежей</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(offerData?.sum_total as number)} ₽
            </span>
          </Box>

          {offerData?.month_pay && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Размер ежемесячного платежа</span>
              <span className={styles.appDescValue}>
                {new Intl.NumberFormat('ru-RU').format(offerData?.month_pay as number)} ₽
              </span>
            </Box>
          )}

          {/* <Box className={styles.appDesc}>*/}
          {/*    <span className={styles.appDescTitle}>Разница</span>*/}
          {/*    <span className={styles.appDescValue}>{new Intl.NumberFormat('ru-RU').format((offerData?.sum_diff) as number)} ₽</span>*/}
          {/* </Box>*/}
          {/* <Box className={styles.appDesc}>*/}
          {/*    <span className={styles.appDescTitle}>Удорожание</span>*/}
          {/*    <span className={styles.appDescValue}>{offerData?.rise_price} %</span>*/}
          {/* </Box>*/}
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Город</span>
            <span className={styles.appDescValue}>{offerData?.city}</span>
          </Box>

          {offerData?.other_info && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Дополнительная информация</span>
              <span className={styles.appDescValue}>{offerData?.other_info}</span>
            </Box>
          )}

          {offerData?.calc && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Расчет по форме</span>
              <DownloadButton fileUrl={offerData?.calc?.url} title={offerData?.calc?.name} />
            </Box>
          )}

          {offerData?.kp && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Коммерческое предложение</span>
              <DownloadButton fileUrl={offerData?.kp?.url} title={offerData?.kp?.name} />
            </Box>
          )}
        </Box>
      );
    }
  };

  const renderFilledOfferCard = (filledOffer: any) => {
    if (type == 'select') {
      return (
        <Box className={styles.offerBlock}>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Состояние</span>
            <span className={styles.appDescValue}>{filledOffer?.condition}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Количество ТС</span>
            <span className={styles.appDescValue}>{filledOffer?.quantity}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Траснспортное средство</span>
            <span className={styles.appDescValue}>
              {filledOffer?.car_type} - {filledOffer?.car_subtype}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Марка</span>
            <span className={styles.appDescValue}>{filledOffer?.car_brand}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Модель</span>
            <span className={styles.appDescValue}>{filledOffer?.vehicle}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Стоимость</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(filledOffer?.price as number)} ₽
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Наличие</span>
            <span
              className={clsx([
                `${styles.appDescValue}`,
                isStock(filledOffer?.availability) && `${styles.stock}`,
                isOrder(filledOffer?.availability) && `${styles.order}`,
              ])}
            >
              {filledOffer?.availability}
            </span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Срок поставки</span>
            <span className={styles.appDescValue}>{filledOffer?.delivery_time}</span>
          </Box>
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Город</span>
            <span className={styles.appDescValue}>{filledOffer?.city}</span>
          </Box>
          {filledOffer?.kp && (
            <Box className={styles.appDesc}>
              <span className={styles.appDescTitle}>Коммерческое предложение</span>
              <DownloadButton fileUrl={filledOffer?.kp?.url} title={filledOffer?.kp?.name} />
            </Box>
          )}
        </Box>
      );
    }

    return (
      <Box className={styles.offerBlock}>
        <Box className={styles.appDesc}>
          <span className={styles.appDescTitle}>Траснспортное средство</span>
          <span className={styles.appDescValue}>
            {appData?.car_type ? `${appData?.car_type} - ` : ''} {appData?.car_subtype || ''}
          </span>
        </Box>
        <Box className={styles.appDesc}>
          <span className={styles.appDescTitle}>Марка</span>
          <span className={styles.appDescValue}>{appData?.car_brand}</span>
        </Box>
        <Box className={styles.appDesc}>
          <span className={styles.appDescTitle}>Модель</span>
          <span className={styles.appDescValue}>{appData?.vehicle}</span>
        </Box>
        <Box className={styles.appDesc}>
          <span className={styles.appDescTitle}>Общая сумма лизинговых платежей</span>
          <span className={styles.appDescValue}>
            {new Intl.NumberFormat('ru-RU').format(filledOffer?.sum_total as number)} ₽
          </span>
        </Box>
        {filledOffer?.month_pay && (
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Размер ежемесячного платежа</span>
            <span className={styles.appDescValue}>
              {new Intl.NumberFormat('ru-RU').format(filledOffer?.month_pay as number)} ₽
            </span>
          </Box>
        )}
        <Box className={styles.appDesc}>
          <span className={styles.appDescTitle}>Город</span>
          <span className={styles.appDescValue}>{filledOffer?.city}</span>
        </Box>
        {filledOffer?.calc && (
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Расчет по форме</span>
            <DownloadButton fileUrl={filledOffer?.calc?.url} title={filledOffer?.calc?.name} />
          </Box>
        )}
        {filledOffer?.kp && (
          <Box className={styles.appDesc}>
            <span className={styles.appDescTitle}>Коммерческое предложение</span>
            <DownloadButton fileUrl={filledOffer?.kp?.url} title={filledOffer?.kp?.name} />
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Box className={styles.offerWrapper}>
      <Box className={styles.offerInside}>
        <span className={styles.header}>{`Заявка № ${appData.id}`}</span>
        {renderApp()}
      </Box>

      <Box className={styles.offerInside}>
        <div className={styles.headerOffer}>
          <span className={styles.header}>Форма заполнения</span>
        </div>

        {filledOffers.length > 0 && (
          <Box className={styles.filledOfferList}>
            {filledOffers.map((filledOffer, index) => (
              <Box
                key={filledOffer?.custom_uid || filledOffer?.id || index}
                className={styles.filledOfferItem}
              >
                <span className={styles.filledOfferTitle}>Заполненная форма #{index + 1}</span>
                {renderFilledOfferCard(filledOffer)}
              </Box>
            ))}
          </Box>
        )}

        {renderOffer()}
        {!fillDisplay && filledOffers.length === 0 && renderFillOffer()}
      </Box>
    </Box>
  );
};
